__turbopack_context__.v({
  "reveal": "ShadowRevealPaper-module__7FhA5W__reveal",
});
